import React from 'react'
import './experience.css'
import {ImHtmlFive} from 'react-icons/im'
import {IoLogoCss3} from 'react-icons/io'
import {TbBrandJavascript} from 'react-icons/tb'
import {FaReact} from 'react-icons/fa'
import {FaNode} from 'react-icons/fa'
import {SiJquery} from 'react-icons/si'
import {FaLaptopCode} from 'react-icons/fa'
import {SiPhp} from 'react-icons/si'
import {SiPostgresql} from 'react-icons/si'
import {SiPostman} from 'react-icons/si'


const experience = () => {
  return (
    <section id='experience'>
      <h5>My Skills</h5>
      <h2>Coding Languages</h2>

      <div className='conatiner experience__container'>
        <div className='experience__frontend'>
          <h3>Frontend Development</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <ImHtmlFive className='experience__details-icon'/>
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <IoLogoCss3 className='experience__details-icon'/>
              <div>
                <h4>CSS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <TbBrandJavascript className='experience__details-icon'/>
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <FaReact className='experience__details-icon'/>
              <div>
                <h4>React</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <FaLaptopCode className='experience__details-icon'/>
              <div>
                <h4>AJAX</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__details'>
              <FaLaptopCode className='experience__details-icon'/>
              <div>
                <h4>JSON</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__details'>
              <SiJquery className='experience__details-icon'/>
              <div>
                <h4>JQUERY</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>

        <div className='experience__backend'>
        <h3>Backend Development</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <FaNode className='experience__details-icon'/>
              <div>
                <h4>Node.Js</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <SiPostgresql className='experience__details-icon'/>
             <div>
                <h4>MySQL</h4>
                <small className='text-light'>Experienced</small>
             </div>
            </article>

            <article className='experience__details'>
              <SiPostman className='experience__details-icon'/>
              <div>
              <h4>API's</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <TbBrandJavascript className='experience__details-icon'/>
              <div>
              <h4>Express</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <SiPhp className='experience__details-icon'/>
              <div>
              <h4>PHP</h4>
              <small className='text-light'>Self Taught</small>
              </div>
            </article>
          </div>
        </div>
      </div>

    </section>
  )
}

export default experience